/* eslint-disable react/prop-types */
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Box, TableCell, TableRow } from "@mui/material";
import React from "react";
import tableStyle from "../../theme/styles/table";
import { isEmptyObj } from "../../utils/helper";
import Button from "../common/Button";
import { style } from "./styles";
import Colors from "../../theme/colors";
import { getGohonzonType } from "../../utils";

const DISABLE_STATUS = [
  "ALLOTTED",
  "ALLOTMENT_CANCELLATION_REQUESTED",
  "ALLOTMENT_CANCELLED",
  "CANCELLED",
];

function GohonzonAllotment({
  member,
  onMemberSelect,
  allotApplication,
  onRejectApplication,
}) {
  const disabledBtn = DISABLE_STATUS.includes(member.status);

  if (isEmptyObj(member) || isEmptyObj(member.memberDetails)) {
    return null;
  }
  const { memberDetails } = member;
  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {memberDetails.memberId}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.fullName || "-"}
        <br />
        {memberDetails.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.mobileNumber || "-"}
        <br />
        {memberDetails.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.divisionName || "-"}
      </TableCell>
      <TableCell style={style.Cell}>{member.regionName || "-"}</TableCell>
      <TableCell style={style.Cell}>
        {getGohonzonType(member.gohonzonType)}
      </TableCell>
      <TableCell style={{ color: "#8C8C8C" }}>
        <Box style={style.flexC}>
          <RemoveRedEyeOutlinedIcon
            style={style.icon}
            onClick={() => onMemberSelect(member.memberId, `allotment/preview`)}
          />
          <Box style={{ ...style.ActionBtnContainer }}>
            <Button
              variant="outlined"
              onClick={() => allotApplication(member)}
              style={
                disabledBtn
                  ? {
                      ...style.actionBtn,
                      opacity: ".5",
                      pointerEvents: "none",
                      marginBottom: "10px",
                      width: "80px",
                      color: Colors.midnightBlue,
                    }
                  : { ...style.actionBtn, marginBottom: "10px", width: "80px" }
              }
              label="ALLOT"
            />
            <Button
              variant="outlined"
              onClick={() => onRejectApplication(member)}
              style={
                disabledBtn
                  ? {
                      ...style.actionBtn,
                      opacity: ".5",
                      pointerEvents: "none",
                      marginBottom: "10px",
                      width: "80px",
                      color: Colors.midnightBlue,
                    }
                  : { ...style.actionBtn, marginBottom: "10px", width: "80px" }
              }
              label="CANCEL"
            />
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonAllotment;
